import React, { useEffect, useMemo, useState } from 'react';
import MasterService from '../services/master/MasterService';

const PropinsiEn = ({ id }) => {
    let masterService = useMemo(() => new MasterService(), [])
    const [propinsi, setPropinsi] = useState('')

    useEffect(() => {
        const getPropinsi = async () => {
            const response = await masterService.getPropinsiById(id)
            setPropinsi(response.data.uraianPropinsiEn)
        }
        getPropinsi()
    }, [masterService, id])

    return (
        <>
            {propinsi}
        </>
    )
}

export default PropinsiEn